<template>
  <v-chip
    class="mt-auto mb-auto sync-chip"
    size="small"
    :disabled="!isEditable || isRevisionSaving"
    @click="onClick"
  >
    Sync

    <template #append>
      <DpplSvg
        class="ml-1"
        file-name="icon-sync"
      />
    </template>
  </v-chip>

  <SyncModal
    :show="syncModalVisible"
    :job-id="jobId"
    :ats-edit-url="atsEditUrl"
    :ats-name="atsName"
    :ats-icon="atsIcon"
    :location="location"
    :company="company"
    :title="title"
    :integration-type-key="integrationTypeKey"
    @close="onClose"
    @tracking-event="$emit('tracking-event', $event)"
  />
</template>

<script>
/* eslint-disable vue/require-prop-types */
import { mapState } from 'pinia';
import { useEditor } from '@/stores/editor/editor';
import DpplSvg from '@/components/datapeople/DpplSvg.vue';
import SyncModal from './SyncModal.vue';

export default {
  name: 'SyncModalButton',

  components: {
    DpplSvg,
    SyncModal,
  },

  props: [
    'jobId',
    'atsEditUrl',
    'atsName',
    'atsIcon',
    'location',
    'company',
    'title',
  ],

  emits: ['tracking-event'],

  data() {
    return {
      syncModalVisible: false,
    };
  },

  computed: {
    ...mapState(useEditor, ['integrationTypeKey', 'isEditable', 'isRevisionSaving']),
  },

  methods: {
    onClose() {
      this.syncModalVisible = false;
    },

    onClick() {
      this.syncModalVisible = true;

      this.$emit('tracking-event', {
        action: 'syncModalOpen',
        args: {
          job: this,
          props: { atsName: this.atsName, integrationTypeKey: this.integrationTypeKey },
        },
      });
    },
  },
};
</script>

<style scoped lang="less">
.sync-chip {
  color: fade(@grey-900, 70%);
  font-size: 14px;
  font-weight: 500;
}
</style>
